// extracted by mini-css-extract-plugin
export var select = "Select-module--select--1eQKU";
export var select__block = "Select-module--select__block--17FIm";
export var select__title = "Select-module--select__title--1w84b";
export var select__open = "Select-module--select__open--35aFG";
export var select__items = "Select-module--select__items--3RYvn";
export var select__item = "Select-module--select__item--JaZqr";
export var select__item_selected = "Select-module--select__item_selected--sxA-B";
export var select__selectedItem = "Select-module--select__selectedItem--150RN";
export var select_openList = "Select-module--select_openList--1ADyl";